import { useData } from "../context/DataContext";
import SEO from "../components/SEO";
import { useMobileOptimization } from "../utils/useMobileOptimization";

export default function Press() {
  const { press: pressItems, loading, error } = useData();
  const { isMobile, prefersReducedMotion, getAnimationClass } =
    useMobileOptimization();

  if (error) {
    return (
      <div className="mt-10 ml-5 w-full flex flex-col animate-fadeInUp max-md:ml-0 max-md:w-full max-md:overflow-x-hidden">
        <h2 className="text-xl font-normal m-0 mb-8 tracking-wide">Press</h2>
        <p>Error loading press: {error}</p>
      </div>
    );
  }

  return (
    <>
      <SEO
        title="Press"
        description="Selected press coverage and critical reviews of Nathan Portelli's recent exhibitions and projects, featuring coverage from MaltaToday, Times of Malta, and other publications."
        url="https://nathanportelli.com/press"
      />
      <div className="mt-10 ml-5 w-full flex flex-col animate-fadeInUp max-md:ml-0 max-md:w-full max-md:overflow-x-hidden">
        <h2 className="text-xl font-normal m-0 mb-8 tracking-wide">Press</h2>

        {loading ? (
          <div className="min-h-96 max-h-96 flex flex-col">
            <div className="flex flex-col items-center justify-center flex-1 min-h-96">
              <div className="flex gap-1 mb-5">
                <div
                  className="w-2 h-2 bg-black rounded-full animate-bounce"
                  style={{ animationDelay: "-0.32s" }}
                ></div>
                <div
                  className="w-2 h-2 bg-black rounded-full animate-bounce"
                  style={{ animationDelay: "-0.16s" }}
                ></div>
                <div className="w-2 h-2 bg-black rounded-full animate-bounce"></div>
              </div>
              <p className="text-gray-600 text-sm m-0 tracking-wide">
                Loading press coverage...
              </p>
            </div>
          </div>
        ) : pressItems.length === 0 ? (
          <div className={`max-w-2xl ${getAnimationClass("animate-fadeIn")}`}>
            <div className="flex flex-col items-center justify-center py-16 text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <svg
                  className="w-8 h-8 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No press coverage yet
              </h3>
              <p className="text-gray-500 text-sm max-w-md">
                Press coverage and reviews will appear here as they become
                available.
              </p>
            </div>
          </div>
        ) : (
          <div className={`max-w-2xl ${getAnimationClass("animate-fadeIn")}`}>
            {pressItems.map((item, index) => (
              <div
                key={item.id}
                className={`flex justify-between items-start py-3 px-3 rounded border border-transparent transition-all duration-200 ${
                  item.link && !isMobile
                    ? "cursor-pointer hover:bg-black hover:bg-opacity-5 hover:border-black hover:border-opacity-10 hover:-translate-y-0.5 hover:shadow-md"
                    : item.link
                    ? "cursor-pointer"
                    : ""
                }`}
                data-clickable={!!item.link}
                onClick={() =>
                  item.link &&
                  window.open(item.link, "_blank", "noopener,noreferrer")
                }
                style={{
                  animationDelay: prefersReducedMotion
                    ? "0s"
                    : `${(index + 1) * (isMobile ? 0.05 : 0.1)}s`,
                  animation: prefersReducedMotion
                    ? "none"
                    : isMobile
                    ? "slideInLeft 0.2s ease-out both"
                    : "slideInLeft 0.4s ease-out both",
                }}
              >
                <div className="flex flex-col">
                  <span className="text-base tracking-wide mb-1">
                    "{item.title}"
                  </span>
                  <span className="text-sm text-gray-600 italic">
                    {item.publisher}
                  </span>
                </div>
                <span className="text-sm text-gray-600 ml-5">{item.date}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
